// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator locations`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* companyHolidays manually fetched by 1 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [companyHolidays, {}] /* Referenced by 4 cases in this module */,
  ] /* Generated file 👉 artifacts/locations-module-settings.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
